/* tslint:disable:max-line-length */
import {
  ContentSideNavButton,
  LeftPaneContent,
  LinkSideNavButton,
  RightDrawerButton,
  SideNavButton,
  SideNavButtonAlignment
} from '@mydocma/app-container';
import {MmSideNavBarButtonsEnum} from './mm-sidenavbar-buttons.enum';
import {
  MmStructureLeftPaneComponent
} from '../mm-filter/structure/mm-structure-left-pane/mm-structure-left-pane.component';
import {MmLayoutLeftPaneComponent} from '../mm-filter/layout/layout-left-pane/layout-left-pane.component';
import {routeToPath} from '../mm-routing/mm-routes.map';
import {MmRoutesEnum} from '../mm-routing/mm-routes.enum';
import {PoolLeftPaneComponent} from '../mm-filter/pool/pool-left-pane/pool-left-pane.component';
import {FieldsLeftPaneComponent} from '../mm-filter/fields/fields-left-pane/fields-left-pane.component';


export const leftPaneContentMap = new Map<string, LeftPaneContent>([
  ['structure', new LeftPaneContent({id: 'structure', componetType: MmStructureLeftPaneComponent})],
  ['layout', new LeftPaneContent({id: 'layout', componetType: MmLayoutLeftPaneComponent})],
  ['pool', new LeftPaneContent({id: 'pool', componetType: PoolLeftPaneComponent})],
  ['fields', new LeftPaneContent({id: 'fields', componetType: FieldsLeftPaneComponent})],
]);

export const buttonsMap: {
  [id: string]: {
    group: MmSideNavBarButtonsEnum,
    button: SideNavButton,
    isExpandedOnInit?: boolean,
    isBackButton?: boolean,
    hasPermission?: boolean
  }
} = {

  [MmSideNavBarButtonsEnum.ProjectOverviewBackToProject]: {
    group: MmSideNavBarButtonsEnum.ProjectOverviewGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectOverviewBackToProject,
      icon: 'arrow_back_ios',
      hidden: true
    }),
    isBackButton: true
  },

  [MmSideNavBarButtonsEnum.ProjectOverview]: {
    group: MmSideNavBarButtonsEnum.ProjectOverviewGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectOverview,
      icon: 'insert_chart_outlined',
      hidden: true
    }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.FilterGroup]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({id: MmSideNavBarButtonsEnum.FilterGroup, icon: 'visibility', expanded: true}),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.FilterStructure]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({
      active: true,
      id: MmSideNavBarButtonsEnum.FilterStructure,
      parentId: MmSideNavBarButtonsEnum.FilterGroup,
      icon: 'account_tree',
      content: leftPaneContentMap.get('structure')
    })
  },

  [MmSideNavBarButtonsEnum.FilterLayout]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({
      id: MmSideNavBarButtonsEnum.FilterLayout,
      parentId: MmSideNavBarButtonsEnum.FilterGroup,
      icon: 'view_column',
      content: leftPaneContentMap.get('layout')
    })
  },

  [MmSideNavBarButtonsEnum.FilterPool]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({
      id: MmSideNavBarButtonsEnum.FilterPool,
      parentId: MmSideNavBarButtonsEnum.FilterGroup,
      icon: '_defect_pool',
      content: leftPaneContentMap.get('pool')
    })
  },

  [MmSideNavBarButtonsEnum.FilterFields]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new ContentSideNavButton({
      id: MmSideNavBarButtonsEnum.FilterFields,
      parentId: MmSideNavBarButtonsEnum.FilterGroup,
      icon: 'filter_alt',
      content: leftPaneContentMap.get('fields')
    })
  },


  [MmSideNavBarButtonsEnum.CostsBackToProject]: {
    group: MmSideNavBarButtonsEnum.CostsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.CostsBackToProject,
      icon: 'arrow_back_ios',
      hidden: true,
      text: 'cost.back',
      tooltip: 'cost.back',
    }),
    isBackButton: true
  },

  // [MmSideNavBarButtonsEnum.TimeTracking]: {
  //   group: MmSideNavBarButtonsEnum.CostsGroup,
  //   button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.TimeTracking, icon: 'schedule', hidden: true, text: 'cost.timeTracking', tooltip: 'cost.timeTracking' })
  // },

  [MmSideNavBarButtonsEnum.Invoices]: {
    group: MmSideNavBarButtonsEnum.CostsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.Invoices,
      icon: 'receipt_long',
      hidden: true,
      text: 'cost.invoices',
      tooltip: 'cost.invoices'
    })
  },


  [MmSideNavBarButtonsEnum.Costs]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new LinkSideNavButton({id: MmSideNavBarButtonsEnum.Costs, icon: '_gold-bars', hidden: true})
  },


  [MmSideNavBarButtonsEnum.Faults]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new LinkSideNavButton({active: true, id: MmSideNavBarButtonsEnum.Faults, icon: 'rule'})
  },

  [MmSideNavBarButtonsEnum.Plans]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    button: new LinkSideNavButton({active: true, id: MmSideNavBarButtonsEnum.Plans, icon: '_plan-view'})
  },

  [MmSideNavBarButtonsEnum.MessageCenter]: {
    group: MmSideNavBarButtonsEnum.MainGroup, button: new RightDrawerButton({
      id: 'task-dashboard',
      alignment: SideNavButtonAlignment.bottom,
      icon: '_megaphone',
      tooltip: 'MM.sidebar.messageCenter',
      text: 'MM.sidebar.messageCenter',
      contentId: 'task-dashboard',
      badgeCount: 0,
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.UserSettingsBackToProject]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.UserSettingsBackToProject,
      icon: 'chevron_left',
      hidden: true
    }),
    isBackButton: true
  },

  [MmSideNavBarButtonsEnum.UserSettingsGroup]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.UserSettingsGroup,
      icon: '_user-settings',
      hidden: true,
      expanded: true,
      active: false
    }),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.UserSettingsVariables]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.UserSettingsVariables,
      parentId: MmSideNavBarButtonsEnum.UserSettingsGroup,
      icon: '_variable-user'
    })
  },

  [MmSideNavBarButtonsEnum.CapacitorAppSettingsBackToProject]: {
    group: MmSideNavBarButtonsEnum.CapacitorAppSettings,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.CapacitorAppSettingsBackToProject,
      icon: 'chevron_left',
      hidden: true
    }),
    isBackButton: true
  },

  [MmSideNavBarButtonsEnum.CapacitorAppSettings]: {
    group: MmSideNavBarButtonsEnum.CapacitorAppSettings,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.CapacitorAppSettings,
      icon: '_capacitor_app_settings',
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsGroup]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_project-config',
      hidden: true,
      expanded: true,
      active: false
    }),
    isExpandedOnInit: true
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsBackToMain]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsBackToMain,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: 'chevron_left',
      hidden: true
    })
  },


  [MmSideNavBarButtonsEnum.ProjectSettingsInformations]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsInformations,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_info',
      hidden: true
    }),
    hasPermission: false
  },
  [MmSideNavBarButtonsEnum.ProjectSettingsMaxLevel]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({ id: MmSideNavBarButtonsEnum.ProjectSettingsMaxLevel, parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup, icon: 'settings', hidden: true }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsStructures]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      active: true,
      id: MmSideNavBarButtonsEnum.ProjectSettingsStructures,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_stacked-organizational-chart',
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsBimModels]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      active: true,
      id: MmSideNavBarButtonsEnum.ProjectSettingsBimModels,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_bim-model',
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsBimSections]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      active: true,
      id: MmSideNavBarButtonsEnum.ProjectSettingsBimSections,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_bim-section',
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsPlans]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      active: true,
      id: MmSideNavBarButtonsEnum.ProjectSettingsPlans,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_plan_without_pin',
      hidden: true
    })
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsCompanies,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_company-config',
      hidden: true
    }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsCrafts,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_crafts',
      hidden: true
    }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectVariables]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectVariables,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_variable-project',
      hidden: true
    }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_project-specifics-1',
      hidden: true
    }),
    hasPermission: false
  },

  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    button: new LinkSideNavButton({
      id: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2,
      parentId: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
      icon: '_project-specifics-2',
      hidden: true
    }),
    hasPermission: false
  }

};

export const urlToButtonMap: {
  [path: string]: { group: MmSideNavBarButtonsEnum, content: MmSideNavBarButtonsEnum }
} = {
  [routeToPath.get(MmRoutesEnum.projects_overview)]: {
    group: MmSideNavBarButtonsEnum.ProjectOverviewGroup,
    content: MmSideNavBarButtonsEnum.ProjectOverview
  },
  // Customer-based costs route (primary) - handled via pattern matching in service
  [routeToPath.get(MmRoutesEnum.costs)]: {
    group: MmSideNavBarButtonsEnum.CostsGroup,
    content: MmSideNavBarButtonsEnum.Costs
  },
  // Customer-based invoices route (primary) - handled via pattern matching in service
  [routeToPath.get(MmRoutesEnum.costs_invoices)]: {
    group: MmSideNavBarButtonsEnum.CostsGroup,
    content: MmSideNavBarButtonsEnum.Invoices
  },
  [routeToPath.get(MmRoutesEnum.faults)]: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    content: MmSideNavBarButtonsEnum.Faults
  },
  [routeToPath.get(MmRoutesEnum.faults) + '?view=plan']: {
    group: MmSideNavBarButtonsEnum.MainGroup,
    content: MmSideNavBarButtonsEnum.Plans
  },
  [routeToPath.get(MmRoutesEnum.user_variables)]: {
    group: MmSideNavBarButtonsEnum.UserSettingsGroup,
    content: MmSideNavBarButtonsEnum.UserSettingsVariables
  },
  [routeToPath.get(MmRoutesEnum.capacitor_app_setting)]: {
    group: MmSideNavBarButtonsEnum.CapacitorAppSettings,
    content: MmSideNavBarButtonsEnum.CapacitorAppSettings
  },
  [routeToPath.get(MmRoutesEnum.project_informations)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsInformations
  },
  [routeToPath.get(MmRoutesEnum.project_settings)]: { group: MmSideNavBarButtonsEnum.ProjectSettingsGroup, content: MmSideNavBarButtonsEnum.ProjectSettingsMaxLevel },
  [routeToPath.get(MmRoutesEnum.co_bim_models)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsBimModels
  },
  [routeToPath.get(MmRoutesEnum.co_structures)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsStructures
  },
  [routeToPath.get(MmRoutesEnum.co_bim_sections)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsBimSections
  },
  [routeToPath.get(MmRoutesEnum.co_plans)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsPlans
  },
  [routeToPath.get(MmRoutesEnum.project_companies)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsCompanies
  },
  [routeToPath.get(MmRoutesEnum.project_crafts)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsCrafts
  },
  [routeToPath.get(MmRoutesEnum.project_variables)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectVariables
  },
  [routeToPath.get(MmRoutesEnum.project_type1)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1
  },
  [routeToPath.get(MmRoutesEnum.project_type2)]: {
    group: MmSideNavBarButtonsEnum.ProjectSettingsGroup,
    content: MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2
  }
};

export const idToUrlMap = new Map<string, string>([
  [MmSideNavBarButtonsEnum.Costs, routeToPath.get(MmRoutesEnum.costs_invoices)],
  [MmSideNavBarButtonsEnum.Faults, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.Plans, routeToPath.get(MmRoutesEnum.faults)],

  [MmSideNavBarButtonsEnum.ProjectSettingsInformations, routeToPath.get(MmRoutesEnum.project_informations)],
  [MmSideNavBarButtonsEnum.ProjectSettingsMaxLevel, routeToPath.get(MmRoutesEnum.project_settings)],

  [MmSideNavBarButtonsEnum.ProjectSettingsBimModels, routeToPath.get(MmRoutesEnum.co_bim_models)],
  [MmSideNavBarButtonsEnum.ProjectSettingsStructures, routeToPath.get(MmRoutesEnum.co_structures)],
  [MmSideNavBarButtonsEnum.ProjectSettingsBimSections, routeToPath.get(MmRoutesEnum.co_bim_sections)],
  [MmSideNavBarButtonsEnum.ProjectSettingsPlans, routeToPath.get(MmRoutesEnum.co_plans)],

  [MmSideNavBarButtonsEnum.UserSettingsBackToProject, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.UserSettingsVariables, routeToPath.get(MmRoutesEnum.user_variables)],

  [MmSideNavBarButtonsEnum.CapacitorAppSettingsBackToProject, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.CapacitorAppSettings, routeToPath.get(MmRoutesEnum.capacitor_app_setting)],

  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies, routeToPath.get(MmRoutesEnum.project_companies)],
  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts, routeToPath.get(MmRoutesEnum.project_crafts)],
  [MmSideNavBarButtonsEnum.ProjectVariables, routeToPath.get(MmRoutesEnum.project_variables)],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1, routeToPath.get(MmRoutesEnum.project_type1)],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2, routeToPath.get(MmRoutesEnum.project_type2)],

  [MmSideNavBarButtonsEnum.ProjectOverview, routeToPath.get(MmRoutesEnum.projects_overview)],
  [MmSideNavBarButtonsEnum.ProjectOverviewBackToProject, routeToPath.get(MmRoutesEnum.faults)],
  [MmSideNavBarButtonsEnum.CostsBackToProject, routeToPath.get(MmRoutesEnum.faults)],
]);


export const idToTranslationKey = new Map<string, string>([
  [MmSideNavBarButtonsEnum.FilterGroup, 'MM.sidebar.view.group'],
  [MmSideNavBarButtonsEnum.FilterStructure, 'MM.sidebar.view.structure'],
  [MmSideNavBarButtonsEnum.FilterLayout, 'MM.layout.layout'],
  [MmSideNavBarButtonsEnum.FilterPool, 'MM.pool.leftPane.title'],
  [MmSideNavBarButtonsEnum.FilterFields, 'MM.fields.leftPane.title'],
  [MmSideNavBarButtonsEnum.Costs, 'cost.costPlural'],
  [MmSideNavBarButtonsEnum.Faults, 'MM.fault.faultPlural'],
  [MmSideNavBarButtonsEnum.Plans, 'MM.plan.plans'],
  [MmSideNavBarButtonsEnum.UserSettingsBackToProject, 'MM.sidebar.userSettings.backToProject'],
  [MmSideNavBarButtonsEnum.UserSettingsGroup, 'MM.sidebar.userSettings.group'],
  [MmSideNavBarButtonsEnum.UserSettingsVariables, 'MM.sidebar.userSettings.variables'],

  [MmSideNavBarButtonsEnum.CapacitorAppSettingsBackToProject, 'MM.sidebar.capacitorAppSettings.backToProject'],
  [MmSideNavBarButtonsEnum.CapacitorAppSettings, 'MM.sidebar.capacitorAppSettings.title'],

  [MmSideNavBarButtonsEnum.ProjectOverview, 'MM.sidebar.projectOverview.group'],
  [MmSideNavBarButtonsEnum.ProjectOverviewBackToProject, 'MM.sidebar.userSettings.backToProject'],
  [MmSideNavBarButtonsEnum.CostsBackToProject, 'cost.back'],
  [MmSideNavBarButtonsEnum.Invoices, 'cost.invoices'],
  // [MmSideNavBarButtonsEnum.TimeTracking, 'cost.timeTracking'],

  [MmSideNavBarButtonsEnum.ProjectSettingsInformations, 'MM.sidebar.projectSettings.informations'],
  [MmSideNavBarButtonsEnum.ProjectSettingsMaxLevel, 'MM.sidebar.projectSettings.maxLevelStructure'],

  [MmSideNavBarButtonsEnum.ProjectSettingsGroup, 'MM.sidebar.projectSettings.group'],
  [MmSideNavBarButtonsEnum.ProjectSettingsBackToMain, '<'],
  [MmSideNavBarButtonsEnum.ProjectSettingsCompanies, 'MM.sidebar.projectSettings.companies'],
  [MmSideNavBarButtonsEnum.ProjectSettingsCrafts, 'MM.sidebar.projectSettings.crafts'],
  [MmSideNavBarButtonsEnum.ProjectVariables, 'MM.sidebar.projectSettings.variables'],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds1, 'MM.sidebar.projectSettings.userdefineds1'],
  [MmSideNavBarButtonsEnum.ProjectSettingsUserdefineds2, 'MM.sidebar.projectSettings.userdefineds2'],

  [MmSideNavBarButtonsEnum.ProjectSettingsBimModels, 'MM.sidebar.bpModels'],
  [MmSideNavBarButtonsEnum.ProjectSettingsStructures, 'MM.sidebar.bpStructures'],
  [MmSideNavBarButtonsEnum.ProjectSettingsBimSections, 'MM.sidebar.bpSections'],
  [MmSideNavBarButtonsEnum.ProjectSettingsPlans, 'MM.sidebar.bpPlans'],

  [MmSideNavBarButtonsEnum.MessageCenter, 'MM.sidebar.messageCenter'],
]);
